import { render, staticRenderFns } from "./QuizQuestionMultipleChoiceV2.vue?vue&type=template&id=adf867e0&scoped=true"
import script from "./QuizQuestionMultipleChoiceV2.vue?vue&type=script&lang=js"
export * from "./QuizQuestionMultipleChoiceV2.vue?vue&type=script&lang=js"
import style0 from "./QuizQuestionMultipleChoiceV2.vue?vue&type=style&index=0&id=adf867e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf867e0",
  null
  
)

export default component.exports